import { InstantConfigResponse } from '../models';

const queryParamPrefixes = ['InstantGlobals', 'icbm'];

function hasInstantConfigPrefix(key: string): boolean {
	return queryParamPrefixes.some((prefix: string) => {
		return key.startsWith(`${prefix}.`) || key.startsWith(`${prefix}__`);
	});
}

type QueryValue = boolean | string | string[] | number | number[] | object | null;

export class InstantConfigOverrider {
	override(queryString: URLSearchParams, config: InstantConfigResponse): InstantConfigResponse {
		return [...queryString.keys()]
			.filter((paramKey: string) => hasInstantConfigPrefix(paramKey))
			.map((paramKey) => {
				const [, key] = paramKey
					.split('.')
					.map((part) => part.split('__'))
					.flat();

				return {
					paramKey,
					key,
				};
			})
			.map(({ paramKey, key }) => ({
				key,
				value: this.parseValue(queryString.get(paramKey)),
			}))
			.reduce((newConfig, { key, value }) => ({ ...newConfig, [key]: value }), config);
	}

	parseValue(value: string): QueryValue {
		if (value === 'true' || value === 'false') {
			return value === 'true';
		}

		const intValue = parseInt(value, 10);
		if (value === `${intValue}`) {
			return intValue;
		}

		try {
			return JSON.parse(value);
		} catch (ignore) {
			return value || null;
		}
	}
}
